import request from 'sb-request'
import { array, getGqlQuery } from 'common/helpers'
import { reducers } from 'redux/core'


const fetch = (params) => {
  const { limit = 15, randomLimit = 0 } = params

  reducers.view.emptyQueueRecommendationModal.setFetching(true)

  const recommendationsQueryParams = getGqlQuery('recommendationsEmptyProduct', {
    limit,
  })

  return request.post('graphql?name=recommendationsEmptyProduct', {
    body: {
      query: `{
        ${recommendationsQueryParams}{
          id
          img
          url
          brand
          name
          category
          price
          sex
          type
          popularIn
          totalPurchasedInState
          totalPurchased
          upchargePrice
          labels
          rating
        }
      }`,
    },
    modifyResult: ({ recommendationsEmptyProduct }) => {
      const products = recommendationsEmptyProduct || []

      if (randomLimit > 0 && products.length > 1) {
        return array.shuffle(products).slice(0, randomLimit)
      }

      return products
    },
  })
    .then((products) => {
      reducers.view.emptyQueueRecommendationModal.setProducts(products)
    }, (error) => {
      console.log(error)

      reducers.view.emptyQueueRecommendationModal.setProducts([])
    })
}


export default {
  fetch,
}
